import { findSize } from './clean-department-utils'
import _ from 'lodash'

export function cleanEntityKps (entity, department, menuBlob) {
  if (!_.has(entity, 'kps')) return

  cleanDisplays(entity.kps, menuBlob)

  let size = findSize(department)
  cleanSizes(entity.kps, size && size.options)
}

function cleanDisplays (kps, menuBlob) {
  if (_.has(kps, 'displays')) {
    const availableDisplays = _.get(menuBlob, 'displays', []).map(next => next.id)
    kps.displays = kps.displays.filter(next => availableDisplays.includes(next))
  }
}

function cleanSizes (kps, sizeOptions) {
  if (_.has(kps, 'excludedSizes')) {
    const availableOptions = (sizeOptions || []).map(next => next.id)
    kps.excludedSizes = kps.excludedSizes.filter(next => availableOptions.includes(next))
  }
}
